import React, { useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
//import { FiSave } from "react-icons/fi";

const PasswordEdit = () => {
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [hasSuccess, setHasSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  //let {id} = useParams();

  const submit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setHasError(false);
    if (newPassword === newPassword2) {
      setHasError(false);
      setLoading(true);
      try {
        const { data } = await axios.post(`selfPassChange`, {
          password,
          new_password: newPassword,
          new_password2: newPassword2,
        });
        if (data.response_code === "0") {
          setHasSuccess(true);
          setSuccessMessage(data.message);
          const timer = setTimeout(() => {
            setRedirect(true);
          }, 3000);

          // Cleanup the timer if the component is unmounted
          return () => clearTimeout(timer);
        } else {
          setHasError(true);
          setErrorMessage(data.message);
        }

        //console.log(data);
      } catch (error) {
        //console.log(error.code);
        if (error.message === "Network Error") {
          setErrorMessage(
            "Failed to connect to the server. Please try again later.",
          );
        } else if (error.code === "ERR_BAD_REQUEST") {
          setErrorMessage(" :: ERR_BAD_REQUEST");
        } else {
          setErrorMessage("An error occurred. Please try again later.");
        }
        setHasError(true);
      } finally {
        setLoading(false);
      }
    } else {
      //error
      setErrorMessage("Passwords do not match");
      setHasError(true);
    }
  };

  if (redirect) {
    return <Navigate to={"/"} />;
  }
  return (
    <Wrapper pageTitle={"Change Password"}>
      <form onSubmit={submit}>
        <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Current Password{" "}
            </span>
            <input
              type="password"
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Old password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              New Password{" "}
            </span>
            <input
              type="password"
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </label>

          <label className="block text-sm">
            <span className="text-gray-700 dark:text-gray-400">
              Re-Type Password{" "}
            </span>
            <input
              type="password"
              className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
              placeholder="Re-type password"
              value={newPassword2}
              onChange={(e) => setNewPassword2(e.target.value)}
            />
          </label>

          <div className="flex mt-6 text-sm">
            <label className="flex items-center dark:text-gray-400">
              <button
                className={`block w-full px-4 py-2 mt-4 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-blue-600 hover:bg-blue-700 focus:outline-none focus:shadow-outline-blue`}
                onClick={submit}
                disabled={loading}
              >
                {loading ? "Loading..." : "Reset"}
              </button>
            </label>
          </div>
        </div>
      </form>
      {hasError && (
        <div className="bg-red-500 text-white leading-5 text-center mt-4 text-sm  px-4 py-2">
          {errorMessage}
        </div>
      )}
      {hasSuccess && (
        <div className="bg-green-500 text-white leading-5 text-center mt-4 text-sm  px-4 py-2">
          {successMessage}
        </div>
      )}
    </Wrapper>
  );
};
export default PasswordEdit;
